import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowStatusMeta } from './core/interface';
import {
  Partners,
  QuoteType,
  QuoteWorkflowStatus,
  RoleType,
} from '@lockton-apps/shared/interfaces';
import { getPartnerWorkflowMeta } from './core/partner-workflow-meta';

@Pipe({
  name: 'workflowMeta',
  standalone: true,
})
export class WorkflowMetaPipe implements PipeTransform {
  transform(
    status: QuoteWorkflowStatus,
    quoteType: QuoteType,
    partner?: Partners,
    userRole?: RoleType
  ): WorkflowStatusMeta {
    return getPartnerWorkflowMeta(status, quoteType, partner, userRole);
  }
}
